/**
 * Named module accents. Modules pick a name, never a hex value; @nexus/ui holds the checked light
 * and dark variants of each accent (docs/ui/design-system.md).
 */
export const MODULE_ACCENTS = [
  'blue',
  'sky',
  'teal',
  'green',
  'lime',
  'amber',
  'orange',
  'red',
  'rose',
  'violet',
  'slate',
] as const;

export type ModuleAccent = (typeof MODULE_ACCENTS)[number];
